import { Gender } from '../../..';

export const genderAdapter = (gender: string): Gender | null => {
    let result = null;

    if (gender) {
        Object.entries(Gender).forEach(([key, value]) => {
            if (value === gender) {
                result = key;
            }
        });
    }

    return result;
};
